import config from '../SysConfig.json';
import { Attachment, MessageItem } from '../components/value_objects';
import dayjs from 'dayjs';
export class annoHelper {
    static async getOpenConditionalAnno(query: string, limit: number, page: number) {

        const resp = await fetch(`/api/open_messages/get_anns?q=${query}&limit=${limit}&page=${page}`);
        return await resp.json() || [];
    }

    static async getOpenConditionalAnnoWithFilters(query: string, limit: number, page: number, tag: string, unit: string) {

        const resp = await fetch(`/api/open_messages/get_anns?q=${query}&limit=${limit}&page=${page}&tag=${tag}&unit=${unit}&is_active=true`);
        return await resp.json() || [];
    }

    static async getOpenAnnoById(id: string | number) {
        const resp = await fetch(`/api/open_messages/get_anns?id=${id}&limit=-1`);
        const data = await resp.json();
        return (data && data.length > 0) ? data[0] : null;
    }

    static async getOpenAnnoCount() {
        const resp = await fetch(`/api/open_messages/get_anns_count`);
        return await resp.json() || [];
    }

    static async getOpenAnnoCountWithFilters(query: string, tag: string, unit: string) {
        const resp = await fetch(`/api/open_messages/get_anns_count?q=${query}&tag=${tag}&unit=${unit}&is_active=true`);
        return await resp.json() || [];
    }

    static async getConditionalAnno(query: string, limit: number, page: number) {
        const resp = await fetch(`/api/announcement/sent_anns?q=${query}&limit=${limit}&page=${page}`);
        return await resp.json() || [];
    }
    static async create(message: MessageItem) {

        const req = {
            attachments: message.attachments,
            content: message.content,
            end_at: (message.end_at === null) ? null : dayjs(message.end_at).format('YYYY-MM-DD'),
            is_top: message.is_top,
            start_at: (message.start_at === null) ? null : dayjs(message.start_at).format('YYYY-MM-DD'),
            title: message.title,
            to_parent: false,
            to_student: true,
            to_teacher: true,
            unit_name: message.unit_name,
            anno_tag: message.anno_tag
        }
        const resp = await fetch(`/api/announcement/create`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(req)
        })
        return await resp.json()
    }
    static async update(message: MessageItem) {
        const req = {
            attachments: message.attachments,
            content: message.content,
            end_at: (message.end_at === null) ? null : dayjs(message.end_at).format('YYYY-MM-DD'),
            is_top: message.is_top,
            start_at: (message.start_at === null) ? null : dayjs(message.start_at).format('YYYY-MM-DD'),
            title: message.title,
            to_parent: false,
            to_student: true,
            to_teacher: true,
            unit_name: message.unit_name,
            anno_tag: message.anno_tag
        }
        const resp = await fetch(`/api/announcement/update/${message.id}`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(req)
        })
        return await resp.json()
    }
    static async delete(id: number) {
        const resp = await fetch(`/api/announcement/delete/${id}`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json',
            },
        })
        return await resp.json()

    }
}
